<template>
    <el-row class="wrapper">
        <el-row class="main">
            <slot></slot>
        </el-row>
    </el-row>
</template>
<script>
export default {
    props: {
        nav: {
            type: String,
            default: '',
        }
    }
}
</script>

<style scoped lang="scss">
.main-bd {
  display: none;
}
.main-bd:last-of-type {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/page/page-sub.vue